import { useEffect, useRef } from 'react';

import { Player } from '../../../types';

type UseTimeUpdate = {
  player: Player | null;
  onTimeChange?: (time: number) => void;
};

const useTimeUpdate = ({ player, onTimeChange }: UseTimeUpdate) => {
  const timeUpdateRef = useRef<() => void>();

  timeUpdateRef.current = () => {
    if (!onTimeChange || !player) return;

    onTimeChange(player.currentTime);
  };

  useEffect(() => {
    if (!player || !timeUpdateRef.current) return;

    player.on('timeupdate', timeUpdateRef.current);

    return () => player.off('timeupdate', timeUpdateRef.current!);
  }, [player]);
};

export default useTimeUpdate;
